import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import NativeCssColors from './NativeCssColors';
import ClientProvider from './client';
export default createDemo(import.meta.url, NativeCssColors, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/css-theme-variables/demos/native-css-colors/NativeCssColors.tsx",
    "fileName": "NativeCssColors.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { ThemeProvider, createTheme } from '@mui/material/styles';\nimport Card from '@mui/material/Card';\nimport CardContent from '@mui/material/CardContent';\nimport CardActions from '@mui/material/CardActions';\nimport Alert from '@mui/material/Alert';\nimport Button from '@mui/material/Button';\n\nconst theme = createTheme({\n  cssVariables: {\n    nativeColor: true,\n    cssVarPrefix: 'nativeColor', // This is for the demo only, you don't need to set this to use the feature\n    colorSchemeSelector: 'data-mui-color-scheme',\n  },\n  colorSchemes: {\n    light: true,\n    dark: true,\n  },\n});\n\nexport default function NativeCssColors() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <Card>\n        <CardContent>\n          <Alert severity=\"info\">\n            This theme uses the <code>oklch</code> color space.\n          </Alert>\n        </CardContent>\n        <CardActions sx={{ justifyContent: 'flex-end' }}>\n          <Button variant=\"contained\" color=\"primary\">\n            Submit\n          </Button>\n          <Button variant=\"outlined\" color=\"primary\">\n            Cancel\n          </Button>\n        </CardActions>\n      </Card>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 40,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { ThemeProvider, createTheme } from '@mui/material/styles';\nimport Card from '@mui/material/Card';\nimport CardContent from '@mui/material/CardContent';\nimport CardActions from '@mui/material/CardActions';\nimport Alert from '@mui/material/Alert';\nimport Button from '@mui/material/Button';\n\nconst theme = createTheme({\n  cssVariables: {\n    nativeColor: true,\n    cssVarPrefix: 'nativeColor', // This is for the demo only, you don't need to set this to use the feature\n    colorSchemeSelector: 'data-mui-color-scheme',\n  },\n  colorSchemes: {\n    light: true,\n    dark: true,\n  },\n});\n\nexport default function NativeCssColors() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ThemeProvider theme={theme}>\n      <Card>\n        <CardContent>\n          <Alert severity=\"info\">\n            This theme uses the <code>oklch</code> color space.\n          </Alert>\n        </CardContent>\n        <CardActions sx={{ justifyContent: 'flex-end' }}>\n          <Button variant=\"contained\" color=\"primary\">\n            Submit\n          </Button>\n          <Button variant=\"outlined\" color=\"primary\">\n            Cancel\n          </Button>\n        </CardActions>\n      </Card>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 40,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Card",
      "@mui/material/CardContent",
      "@mui/material/CardActions",
      "@mui/material/Alert",
      "@mui/material/Button"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
